import { type ReactNode, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { IntlProvider } from "react-intl";
import { type SupportedLocale, getMessages } from "./messages.js";

type Props = {
  locale: SupportedLocale;
  children: ReactNode;
};

export function AppIntlProvider({ locale, children }: Props) {
  // Browser: keep DOM in sync via imperative write (immediate, no re-render).
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <IntlProvider locale={locale} defaultLocale="en" messages={getMessages(locale)}>
      {/* SSR: emit lang via helmet so the prerender script picks it up. */}
      <Helmet htmlAttributes={{ lang: locale }} />
      {children}
    </IntlProvider>
  );
}
